/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Declinedeal_Reasons_Other2Inputs */

const en_coinvestments_declinedeal_reasons_other2 = /** @type {(inputs: Coinvestments_Declinedeal_Reasons_Other2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Other`)
};

/**
* | output |
* | --- |
* | "Other" |
*
* @param {Coinvestments_Declinedeal_Reasons_Other2Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_declinedeal_reasons_other2 = /** @type {((inputs?: Coinvestments_Declinedeal_Reasons_Other2Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Declinedeal_Reasons_Other2Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_declinedeal_reasons_other2(inputs)
});
export { coinvestments_declinedeal_reasons_other2 as "coInvestments_declineDeal_reasons_other" }